/*
 * a Collection of regions, each showing the survey label for a single language
 */

define(["marionette", "./template/cancelActionLabelsTemplate.html"], function (
  Marionette,
  CancelActionLabelsTemplate,
) {
  var CancelActionLabelsView = {};

  CancelActionLabelsView.cancelActionLabelsLayout = Marionette.Layout.extend({
    template: CancelActionLabelsTemplate,
    regions: {
      touchPointSelect: "#touchPointSelect",
      cancelActionLabelDisplay: "#cancelActionLabelDisplay",
    },
  });

  return CancelActionLabelsView;
});
